module.exports = __webpack_public_path__ + "img/joon yorigami_lw.b0a90ead.png";